import * as React from 'react';
/**
 *
 * Original name: cloud upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29931%3A6845
 *
 */
export const CloudUploadPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M44 25c0-7.626-4.374-12-12-12s-12 4.374-12 12c-7.626 0-12 4.374-12 12s4.374 12 12 12v-4c-5.458 0-8-2.542-8-8s2.542-8 8-8h4v-4c0-5.458 2.542-8 8-8s8 2.542 8 8v4h4c5.458 0 8 2.542 8 8s-2.542 8-8 8v4c7.626 0 12-4.374 12-12s-4.374-12-12-12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M30 37.926V49h4V37.926a16.774 16.774 0 0 0 4.106 2.864l1.789-3.578A11.347 11.347 0 0 1 34 31h-4a11.352 11.352 0 0 1-5.895 6.211l1.789 3.578A16.773 16.773 0 0 0 30 37.926Z", fill: "currentColor" })));
